import * as Yup from 'yup';
import {t} from 'ttag';

export const invoiceEditValidationSchema = Yup.object().shape({
  billingName: Yup.string().max(40, t`Billing name should not exceed 40 characters.`).required(t`Required field.`),
  endorsement: Yup.string(),
  email: Yup.string()
    .nullable()
    .required(t`Required field.`)
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, t`This email is not valid.`),
  country: Yup.object({
    code: Yup.string().required(t`Country code is required.`),
    label: Yup.string().required(t`Country label is required.`),
  }).required(t`Required field.`),
  city: Yup.string().required(t`Required field.`),
  address: Yup.string().max(60, t`Address should not exceed 60 characters.`).required(t`Required field.`),
  postalCode: Yup.string().required(t`Required field.`),
  taxId: Yup.string().required(t`Required field.`)
});
